import { create } from 'zustand';
import type { Project, PublicProjectListItem } from '../lib/api';

export interface ProjectsFilters {
  search?: string;
  status?: string;
  /** Showcase: category/niche filter */
  category?: string | null;
  /** Showcase: project status tags (e.g. MVP, Production) */
  statuses?: string[];
}

export interface PaginationState {
  offset: number;
  limit: number;
}

interface ProjectsState {
  projects: Project[];
  publicProjects: PublicProjectListItem[];
  filters: ProjectsFilters;
  pagination: PaginationState;
  setProjects: (projects: Project[]) => void;
  setPublicProjects: (projects: PublicProjectListItem[]) => void;
  setFilters: (filters: ProjectsFilters | ((prev: ProjectsFilters) => ProjectsFilters)) => void;
  setPagination: (pagination: PaginationState | ((prev: PaginationState) => PaginationState)) => void;
}

export const useProjectsStore = create<ProjectsState>((set) => ({
  projects: [],
  publicProjects: [],
  filters: {},
  pagination: { offset: 0, limit: 50 },

  setProjects: (projects) => set({ projects }),

  setPublicProjects: (publicProjects) => set({ publicProjects }),

  setFilters: (filters) =>
    set((state) => ({
      filters: typeof filters === 'function' ? filters(state.filters) : filters,
    })),

  setPagination: (pagination) =>
    set((state) => ({
      pagination: typeof pagination === 'function' ? pagination(state.pagination) : pagination,
    })),
}));
